import {
  PRESET_SECURITY_QUESTIONS,
  ValidateYup,
} from "@tastyworks/tastyworks-api"
import { boolean, object, string } from "yup"

const { buildSchema } = ValidateYup

const schema = object({
  hasCreated: boolean().defined().default(false),
  answer: string()
    .required()
    .when(["hasCreated"], ([$hasCreated], schema) => {
      if ($hasCreated) {
        return schema.notRequired()
      }
      return schema
    }),
  customQuestion: string()
    .when("presetQuestion", {
      is: PRESET_SECURITY_QUESTIONS[0],
      otherwise: (schema) => schema.notRequired(),
      then: (schema) => schema.required(),
    })
    .defined(),
  presetQuestion: string()
    .required()
    .oneOf(Array.from(PRESET_SECURITY_QUESTIONS))
    .when(["hasCreated"], ([$hasCreated], schema) => {
      if ($hasCreated) {
        return schema.notRequired()
      }
      return schema
    }),
})

export const securityQuestionSchema = buildSchema("SecurityQuestion", schema)

/* v8 ignore start -- @preserve */
if (import.meta.vitest) {
  const { it, expect, describe } = import.meta.vitest

  describe("securityQuestionSchema", () => {
    describe("hasCreated", () => {
      it("validates correctly", async () => {
        const input = {
          hasCreated: false,
          answer: "answer",
          presetQuestion: "What was your childhood nickname?",
        }

        const result = await securityQuestionSchema.validate(input)

        expect(result).toEqual(input)
      })

      it("defaults hasCreated to false when not passed", async () => {
        const input = {
          answer: "answer",
          presetQuestion: "What was your childhood nickname?",
        }

        const result = await securityQuestionSchema.validate(input)

        expect(result).toEqual({ ...input, hasCreated: false })
      })
    })

    describe("answer", () => {
      it("is not required when hasCreated is true", async () => {
        const input = {
          hasCreated: true,
          presetQuestion: "What was your childhood nickname?",
        }

        const result = await securityQuestionSchema.validate(input)

        expect(result).toEqual(input)
      })
    })

    describe("customQuestion", () => {
      it("throws when the preset question specifically specifies a custom question and no custom question is provided", async () => {
        const input = {
          hasCreated: false,
          answer: "abc",
          presetQuestion: "I want to write my own security question",
        }

        await expect(() =>
          securityQuestionSchema.validate(input)
        ).rejects.toThrow()
      })
    })
  })
}
